import React, { PureComponent } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

class LoginForgotPasswordDialog extends PureComponent {
  render () {
    const { open, handleClose, email } = this.props
    
    return (
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>We're here to help!</DialogTitle>
        <DialogContent>
          <Typography>We sent an email to {email} with a link to reset your password.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">Close</Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default LoginForgotPasswordDialog



// WEBPACK FOOTER //
// ./src/components/LoginForgotPasswordDialog.js